import { useEffect, useState } from 'react';

const DEFAULT_QUERY = '(max-width: 640px)';

/**
 * Shared hook that listens for viewport changes using matchMedia.
 * Falls back gracefully when window is undefined (SSR/preview environments).
 */
export default function useIsMobile(query = DEFAULT_QUERY) {
  const getMatches = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(query);
    const updateMatch = (event) => setMatches(event.matches);

    // Sync initial value in case query changed between renders
    setMatches(mediaQueryList.matches);

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', updateMatch);
    } else if (typeof mediaQueryList.addListener === 'function') {
      mediaQueryList.addListener(updateMatch);
    }

    return () => {
      if (typeof mediaQueryList.removeEventListener === 'function') {
        mediaQueryList.removeEventListener('change', updateMatch);
      } else if (typeof mediaQueryList.removeListener === 'function') {
        mediaQueryList.removeListener(updateMatch);
      }
    };
  }, [query]);

  return matches;
}
